<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 pr-1">

        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToManageBrief()" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                @if (creator() && focussedBrief()) {
                <div (click)="launchPortfolio()" class="group inline-flex gap-x-2 cursor-pointer">
                    <h3 class="text-md font-semibold text-primary group-hover:underline">
                        {{
                        creator()!.firstName + ' ' +
                        creator()!.lastName.charAt(0) + '.'
                        }}
                    </h3>
                    <span
                        class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset"
                        [class]="getBadgeColour(focussedBrief)">{{
                        getPostType()
                        }}</span>
                </div>
                <p class="mt-0 text-xs text-secondary">{{ focussedBrief() ? focussedBrief()!.title : 'Loading...' }}</p>
                }
            </div>
        </div>

        <div class="flex-1 flex flex-row items-center justify-end gap-x-2">

            @if (focussedBrief() && creatorId() && focussedApplication()) {

            <vs-payment-status *appHasRole="[2, 5, 7]" [creatorId]="creatorId()!"
                [focussedApplication]="focussedApplication()!" [brief]="focussedBrief()!"
                [creator]="creator()!"></vs-payment-status>
            <!-- <vs-payment-status [creatorId]="creatorId()!" [focussedApplication]="focussedApplication()!" [brief]="focussedBrief()!" [creator]="creator()!"></vs-payment-status> -->


            <vs-upload-draft [briefId]="focussedBrief()!.id" [creatorId]="creatorId()!"
                [briefApplicationId]="focussedApplication()!.id" [focussedApplication]="focussedApplication()!"
                (videoUploaded)="onVideoUploaded($event)"></vs-upload-draft>

            <button *appHasRole="[6]" type="button" (click)="copyUrlAndOpenAdminSettings()"
                class="inline-flex items-center gap-x-2 rounded-(--radius) bg-rose-600 px-2 py-1 text-xs font-semibold text-white transition-all duration-300 ease-in-out hover:bg-rose-500 cursor-pointer">
                Admin Settings
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1"
                    aria-hidden="true">
                    <path d="M15 3h6v6" />
                    <path d="M10 14 21 3" />
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                </svg>
            </button>

            <!-- <button type="button" (click)="showReviewModal.set(true)" class="primary-button-primary">Review
                Submission</button> -->
            }

            @if (focussedApplication()) {
            <vs-status-history [applicationStatus]="focussedApplication()!.applicationStatus"
                [statusHistory]="focussedApplication()!.statusHistory"
                [selectedApplication]="focussedApplication()!"></vs-status-history>
            }
        </div>
    </div>

    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">

        <div class="grid grid-cols-1 lg:grid-cols-12 gap-y-2 lg:gap-x-2 h-full">

            @if (showsPlacementPanel()) {
            <article
                class="col-span-1 lg:col-span-4 2xl:col-span-3 flex flex-col flex-1 overflow-hidden rounded-xl bg-white dark:bg-gray-800 shadow border border-border shadow-sm">

                <vs-creator-distribution class="h-full" [brief]="focussedBrief()"
                    [application]="focussedApplication()" [creator]="creator()"
                    (cancelled)="onCrossPlatformCancelled($event)"></vs-creator-distribution>

            </article>
            }

            <article class="col-span-1 lg:col-span-4 2xl:col-span-6 flex flex-col gap-y-2 flex-1 overflow-hidden" [class]="getWidthBasedOnCrossPlatforms()">


                @if (focussedApplication() && bonusActiveStatuses.includes(focussedApplication()!.applicationStatus)) {
                <div class="shrink-0 w-full flex flex-row gap-x-4">
                    <div
                        class="flex-1 rounded-lg bg-green-50 dark:bg-green-900/30 p-4 ring-1 ring-inset ring-green-600 ring-green-20">
                        <div class="flex">
                            <div class="shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="size-8 text-green-400">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
                                </svg>

                            </div>
                            <div class="ml-3 w-full flex flex-row justify-between items-center">
                                <div class="w-full flex flex-col">

                                    <h3 class="text-sm font-semibold text-green-800 dark:text-green-200">Tip your
                                        Creator</h3>
                                    <div class="hidden sm:block text-xs text-green-700 dark:text-green-200/85">
                                        <p>Has {{ creator()?.firstName }} done a great job?</p>
                                    </div>
                                </div>
                                <div class="w-full flex flex-row items-center justify-end gap-x-2">
                                    @if (bonusPaid()) {
                                    <p
                                        class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200 dark:text-white dark:ring-white/10">
                                        <svg viewBox="0 0 6 6" aria-hidden="true"
                                            class="size-1.5 fill-green-500 dark:fill-green-400">
                                            <circle r="3" cx="3" cy="3" />
                                        </svg>
                                        <span>
                                            {{bonusAmount() | currency: bonusCurrency().toUpperCase()}} - Bonus Paid,
                                            Thanks!
                                        </span>
                                    </p>
                                    }
                                    <!-- @else { -->
                                    <button type="button" (click)="payBonus()" class="primary-button-success">Pay
                                        Bonus</button>
                                    <!-- } -->
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                }

                <!--
                    Where this creator has posted. Renders itself only for cross-platform
                    briefs, so every other brief's layout is untouched.
                -->


                <div
                    class="flex-1 w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow flex flex-col min-h-0 rounded-xl border border-border shadow-sm">
                    <div class="border-b border-gray-200 px-3 py-3 dark:border-white/10 shrink-0 bg-muted/50">
                        <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                            <div class="flex flex-row items-center justify-start gap-x-2">

                                <div class="flex flex-col items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-accent">
                                        <path
                                            d="M4 12V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2" />
                                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                        <path
                                            d="m10 17.843 3.033-1.755a.64.64 0 0 1 .967.56v4.704a.65.65 0 0 1-.967.56L10 20.157" />
                                        <rect width="7" height="6" x="3" y="16" rx="1" />
                                    </svg>
                                </div>
                                <div class="flex flex-col">
                                    <h3 class="text-sm font-semibold text-primary">Submitted Content</h3>
                                    <p class="hidden sm:block mt-0.5 text-xs text-secondary">Find all the
                                        content that
                                        has been submitted for this brief by this creator.</p>
                                </div>
                            </div>
                            <div class="shrink-0 flex flex-row items-center gap-x-2">

                                <!-- Download All -->
                                @if (approvedVideoCount() > 0) {
                                <button type="button" (click)="downloadAllApproved()" [disabled]="isDownloadingAll()"
                                    class="fab-button-secondary flex items-center gap-x-1.5 disabled:opacity-50 disabled:cursor-not-allowed">
                                    @if (isDownloadingAll()) {
                                    <svg aria-hidden="true" class="size-4 animate-spin text-gray-400 fill-primary"
                                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="currentColor" />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentFill" />
                                    </svg>
                                    } @else {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <path d="M12 15V3" />
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                        <path d="m7 10 5 5 5-5" />
                                    </svg>
                                    }
                                    <span class="text-xs">Download All ({{ approvedVideoCount() }})</span>
                                </button>
                                }
                                <!-- Download All END -->

                                <!-- Brief Status -->
                                <div class="flex flex-col min-w-30">
                                    <el-select id="brief-status-select" name="selected" class="block">
                                        <button type="button"
                                            class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
                                            <el-selectedcontent class="col-start-1 row-start-1 truncate pr-6">
                                                @if (selectedStatusFilter() !== undefined) {
                                                {{ selectedStatusFilterLabel() }}
                                                } @else {
                                                <span class="block truncate">All Videos</span>
                                                }
                                            </el-selectedcontent>
                                            <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon"
                                                aria-hidden="true"
                                                class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-400 sm:size-4">
                                                <path
                                                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                                    clip-rule="evenodd" fill-rule="evenodd" />
                                            </svg>
                                        </button>

                                        <el-options anchor="bottom start" popover [value]="selectedStatusFilter()"
                                            class="dropdown-select-primary-menu">
                                            @for (status of statusOptions(); track status.id) {
                                            <el-option [value]="$index" (click)="selectStatusFilter(status)"
                                                class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                                                <span
                                                    class="block truncate font-normal group-aria-selected/option:font-semibold">{{
                                                    status.name }}</span>
                                                <span
                                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden">
                                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                        aria-hidden="true" class="size-5">
                                                        <path
                                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                            clip-rule="evenodd" fill-rule="evenodd" />
                                                    </svg>
                                                </span>
                                            </el-option>
                                            }
                                        </el-options>
                                    </el-select>
                                </div>
                                <!-- Brief Status END -->

                                @if (showAffiliateDrawerButton()) {
                                <button type="button"
                                    class="btn-shout btn-shout-sm btn-shout-plus-gradient"
                                    (click)="openAffiliateDrawer()" title="Affiliate assignment"
                                    aria-label="Open affiliate assignment" [disabled]="affiliateAssignmentLoading()">
                                    <sp-remuneration-type-icon [type]="PaymentMethodTypeEnum.AFFILIATE"
                                        iconClass="size-5" />
                                        Affiliate overview
                                </button>
                                }

                            </div>
                        </div>
                    </div>

                    <div class="p-2 overflow-y-auto flex-1 min-h-0 scrollbar-transparent">
                        <!-- Ad License explainer strip -->
                        @if (eligibleLicenseQuote(); as licenseQuote) {
                        <div *appHasRole="[77]" class="mb-3 flex flex-wrap items-center gap-3 rounded-lg bg-[#F0E6FE] px-4 py-3 dark:bg-violet-900/30"
                            data-testid="ad-license-strip">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                stroke="#6508FB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="shrink-0" aria-hidden="true">
                                <path d="m3 11 18-5v12L3 14v-3z" />
                                <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
                            </svg>
                            <p class="min-w-[220px] flex-1 text-sm font-semibold text-[#2B2340] dark:text-violet-100">
                                <strong class="font-extrabold">Turn approved videos into ads.</strong> An Ad License lets you
                                boost a video on your own channels or run it as a dark ad for {{ licenseQuote.termDays }} days.
                            </p>
                            <span class="text-sm font-extrabold text-[#6508FB] dark:text-violet-300 tabular-nums">{{
                                licenseQuote.brandPrice / 100 | currency: licenseQuote.currencyCode.toUpperCase() }} per
                                video</span>
                        </div>
                        }
                        @if (displayVideos() && displayVideos()!.length > 0) {
                        <ul role="list" class="grid grid-cols-1 gap-3"
                            [class]="focussedBrief() && focussedBrief()!.videoFormat === 1 ? 'sm:grid-cols-2' : 'sm:grid-cols-4 2xl:grid-cols-4'">
                            @for (video of displayVideos()!; track $index) {
                            <vs-draft-item-thumb [video]="video"
                                [videoFormat]="focussedBrief() && focussedBrief()!.videoFormat ? focussedBrief()!.videoFormat : 0"
                                [licenseQuote]="eligibleLicenseQuote()" [license]="licensesByVideoId()[video.id]"
                                (showVideoFeedback)="showVideoFeedback.set($event)"
                                (videoApproved)="videoApproved($event)" (buyLicense)="openLicenseModal($event)"
                                (cancelLicense)="cancelLicense($event)"></vs-draft-item-thumb>
                            }
                        </ul>
                        } @else if (displayVideos() && displayVideos()!.length == 0) {
                        <div class="w-full h-full flex flex-col items-center justify-center px-6 py-10">
                            @if (applicationVideos() && applicationVideos()!.length > 0) {
                            <div class="max-w-sm text-center">
                                <div
                                    class="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-zinc-100 dark:bg-zinc-700/60">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" aria-hidden="true"
                                        class="size-7 text-zinc-400 dark:text-zinc-400">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
                                    </svg>
                                </div>
                                <h3 class="text-sm font-semibold text-primary">No matching drafts</h3>
                                <p class="mt-1 text-xs text-secondary">
                                    Nothing matches this status filter. Switch back to All to see every draft from this
                                    creator.
                                </p>
                            </div>
                            } @else {
                            <div class="max-w-md text-center">
                                <div
                                    class="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-violet-50 dark:bg-violet-500/10 ring-1 ring-inset ring-violet-500/20">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" aria-hidden="true"
                                        class="size-7 text-violet-500 dark:text-violet-400">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z" />
                                    </svg>
                                </div>
                                <h3 class="text-sm font-semibold text-primary">
                                    @if (creator()?.firstName) {
                                    Waiting for {{ creator()!.firstName }}'s first draft
                                    } @else {
                                    Waiting for the first draft
                                    }
                                </h3>
                                <p class="mt-1.5 text-xs text-secondary">
                                    Drafts will land here as soon as they're uploaded. While you wait, say hello in chat
                                    — a quick welcome helps kick things off.
                                </p>
                                <ul class="mt-5 space-y-2 text-left">
                                    <li
                                        class="flex items-start gap-x-3 rounded-lg bg-zinc-50 dark:bg-zinc-900/60 px-3 py-2.5 ring-1 ring-inset ring-zinc-200/80 dark:ring-white/5">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" aria-hidden="true"
                                            class="mt-0.5 size-4 shrink-0 text-violet-500 dark:text-violet-400">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" />
                                        </svg>
                                        <div class="min-w-0">
                                            <p class="m-0 text-xs font-medium text-primary">Send a welcome message</p>
                                            <p class="m-0 mt-0.5 text-xs text-secondary">Share timing, product details,
                                                or
                                                any creative notes.</p>
                                        </div>
                                    </li>
                                    <li
                                        class="flex items-start gap-x-3 rounded-lg bg-zinc-50 dark:bg-zinc-900/60 px-3 py-2.5 ring-1 ring-inset ring-zinc-200/80 dark:ring-white/5">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" aria-hidden="true"
                                            class="mt-0.5 size-4 shrink-0 text-violet-500 dark:text-violet-400">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                        </svg>
                                        <div class="min-w-0">
                                            <p class="m-0 text-xs font-medium text-primary">Or upload on their behalf
                                            </p>
                                            <p class="m-0 mt-0.5 text-xs text-secondary">Use Upload Draft above if you
                                                already have the file.</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            }
                        </div>
                        } @else {

                        <div class="flex h-full w-full items-center justify-center">
                            <app-loading-inline title="Loading..."
                                message="Loading submissions..."></app-loading-inline>
                        </div>
                        }
                    </div>
                </div>
            </article>


            <article
                class="col-span-1 lg:col-span-4 2xl:col-span-3 flex flex-col flex-1 overflow-hidden card-container-pale-no-padding">

                <div class="h-full w-full flex flex-col overflow-hidden">
                    <div class="shrink-0 flex flex-row items-center w-full gap-x-4 p-4">
                        <div class="shrink-0">
                            <!-- <img src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                alt="" class="size-10 rounded-full bg-gray-50" /> -->
                            <div class="size-10 flex-none rounded-full bg-gray-50 overflow-hidden hover:cursor-pointer"
                                (click)="launchPortfolio()">
                                <atom-ldg-img inputClass="object-cover" h="full" w="full" radius="lg"
                                    [src]="creator() && creator()!.photoURL ? imageService.getImageSource(creator()!.photoURL, 'gallery') : 'https://ionicframework.com/docs/img/demos/card-media.png'"></atom-ldg-img>
                            </div>
                        </div>
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-semibold text-primary">
                                {{ creator() && creator()!.firstName + ' ' + creator()!.lastName.charAt(0) + '.' }}
                            </p>
                            <p class="m-0 text-xs text-secondary">
                                @if (applicationVideos() && applicationVideos()!.length > 0) {
                                @if (applicationVideos()!.length === 1) {
                                {{ applicationVideos()!.length }} Submission
                                } @else {
                                {{ applicationVideos()!.length }} Submissions
                                }
                                } @else if (applicationVideos() && applicationVideos()!.length == 0) {
                                Waiting for first draft
                                } @else {
                                Loading submissions…
                                }
                            </p>
                        </div>
                        <div class="flex shrink-0 self-center text-transparent">
                            RHS
                        </div>
                    </div>

                    @if (applicationVideos() && applicationVideos()!.length > 0) {
                    <div
                        class="shrink-0 mx-3 mb-2 flex items-center gap-x-2 rounded-lg bg-violet-50 px-3 py-2 ring-1 ring-inset ring-violet-500/20 dark:bg-violet-500/10 dark:ring-violet-400/20">
                        <p class="m-0 min-w-0 flex-1 text-xs text-violet-900 dark:text-violet-100">
                            Use this chat for general questions and updates.
                        </p>
                        <button type="button" (click)="openLatestVideoFeedback()"
                            class="shrink-0 inline-flex items-center gap-x-1 rounded-md bg-violet-600 px-2 py-1 text-xs font-semibold text-white hover:bg-violet-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 dark:bg-violet-500 dark:hover:bg-violet-400">
                            Leave video feedback
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" aria-hidden="true" class="size-3.5">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                            </svg>
                        </button>
                    </div>
                    }

                    @if (chatViewReady()) {
                    <div class="flex-1 flex flex-col items-center overflow-hidden">
                        <div class="flex flex-col h-full w-full overflow-hidden chat-body">
                            <stream-channel class="h-full w-full flex flex-col overflow-hidden rounded-lg">
                                <div class="flex-1 overflow-y-auto">
                                    <stream-message-list class="h-full"></stream-message-list>
                                </div>
                                <div id="input-container" class="shrink-0">
                                    <!-- <stream-message-input [autoFocus]="false" class="w-full"></stream-message-input> -->
                                    <stream-message-input>

                                    </stream-message-input>
                                </div>
                            </stream-channel>
                        </div>
                    </div>
                    } @else if (!chatLoadingError()) {
                    <div class="flex-1 h-full flex flex-col items-center justify-center overflow-hidden">
                        <atom-loading-inline title="Loading..." message="Loading chat..."></atom-loading-inline>
                    </div>
                    } @else {
                    <div class="h-full flex flex-col items-center justify-center">
                        @if (!joiningChat()) {
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                                <path d="M12 12v4" />
                                <path d="M12 20h.01" />
                                <path d="M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708" />
                            </svg>
                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Whoops!</h3>
                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Looks like you're not in on this
                                chat...</p>
                            <div class="mt-6">

                                <button type="button" (click)="joinStreamChat()"
                                    class="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="-ml-0.5 mr-1.5 size-5">
                                        <path
                                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                    </svg>
                                    Join Chat
                                </button>

                            </div>
                        </div>
                        } @else {
                        <div class="h-full w-full flex flex-col items-center justify-center">
                            <atom-loading-inline title="Loading..." message="Joining chat..."></atom-loading-inline>
                        </div>
                        }
                    </div>
                    }
                </div>

            </article>
        </div>

    </div>
</div>

<ng-template #emptyChatTemplate>
    <div class="vs-empty-chat flex w-full flex-col items-center px-6 py-4 text-center">
        <div
            class="mb-4 flex size-12 items-center justify-center rounded-2xl bg-white/80 dark:bg-zinc-800/80 ring-1 ring-inset ring-zinc-200/80 dark:ring-white/10 shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" aria-hidden="true" class="size-6 text-violet-500 dark:text-violet-400">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.059-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
            </svg>
        </div>
        <h3 class="text-sm font-semibold text-primary">
            @if (creator()?.firstName) {
            Say hi to {{ creator()!.firstName }}
            } @else {
            Start the conversation
            }
        </h3>
        <p class="mt-1.5 max-w-xs text-xs text-secondary">
            You've hired them — a short welcome message is a great way to share expectations, timelines, or creative
            direction.
        </p>
        <p class="mt-4 text-xs font-medium text-violet-600 dark:text-violet-400">
            Type below to send your first message
        </p>
    </div>
</ng-template>

@if (showVideoFeedback() && creator() && focussedApplication()) {
<vs-video-feedback (close)="showVideoFeedback.set(undefined)" [video]="showVideoFeedback()"
    [videos]="applicationVideos() ?? []" [creator]="creator()!" [isUgcOnly]="getIsUgcOnly()"
    [videoFormat]="focussedBrief()!.videoFormat" [briefApplication]="focussedApplication()"
    (videoChange)="showVideoFeedback.set($event)" (approveVideo)="videoApproved(true)"
    [licenseQuote]="eligibleLicenseQuote()" [licensesByVideoId]="licensesByVideoId()"
    [keyboardSuspended]="!!licenseModalVideo()" (buyLicense)="openLicenseModal($event)"></vs-video-feedback>
}

@if (licenseModalVideo() && eligibleLicenseQuote()) {
<vs-buy-ad-license-modal [video]="licenseModalVideo()!" [quote]="eligibleLicenseQuote()!"
    [draftLabel]="draftLabel(licenseModalVideo()!)" [creatorFirstName]="creator()?.firstName || 'The creator'"
    (licenseRequested)="onLicenseRequested($event)"
    (close)="licenseModalVideo.set(undefined)"></vs-buy-ad-license-modal>
}

@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}

@if (showPayonusModal()) {
<vs-pay-bonus [creator]="creator()!" [brief]="focussedBrief()!" [briefApplicationId]="focussedApplication()!.id"
    (close)="showPayonusModal.set(false)"></vs-pay-bonus>
}

@if (showReviewModal()) {
<vs-review-modal [creator]="creator()!" [brief]="focussedBrief()!" [briefApplicationId]="focussedApplication()!.id"
    (closeReviewModal)="reviewSubmitted($event)"></vs-review-modal>
}

<app-shopify-affiliate-assignment #shopifyAffiliateDrawer />
<app-rakuten-affiliate-assignment #rakutenAffiliateDrawer />